export default {
  install(Vue, options) {
    /**
     * Reduce an object to a specified path
     * @example this.$reduce(someObject, 'some.long.path.you.want.to.access')
     * @param {Object} obj - the source object to reduce
     * @param {String} path - the . separated path to access
     * @returns {Mixed} - undefined if the path does not exist
     */
    Vue.prototype.$reduce = (obj, path) => {
      if ('object' !== typeof obj || 'string' !== typeof path) {
        return undefined;
      }
      return path.split('.')
        .reduce((currentObject, currentPath) => {
          return currentObject ? currentObject[currentPath] : undefined;
        }, obj);
    };
  }
};
